import axios from 'axios';
import { SAVE_MESSAGE, CHATBOT_USER, SAVE_MANAGE_CODE, CHATBOT_LOGIN, SAVE_TIME, SAVE_APPLY_LIST, GET_WELCOME_LIST, LOGIN_USER, AUTH_USER, LOGOUT_USER } from './types';


export async function saveMessage(formData) {

    let deleteYn = false;

    if(formData && formData.delete) {
        deleteYn = true
    }
    
    return {
        delete : deleteYn,
        type: SAVE_MESSAGE,
        payload: formData
    }
}
export async function saveApplyList(formData) {

    return {
        type: SAVE_APPLY_LIST,
        payload: formData
    }
}
export async function saveMangeCode(formData) {

    return {
        type: SAVE_MANAGE_CODE,
        payload: formData
    }
}
export async function saveTime(formData) {

    return {
        type: SAVE_TIME,
        payload: formData
    }
}
export async function chatbotMsg(formData) {

    const request = await axios.post('/v1/bot/message', formData)
      
    return {
        type: CHATBOT_USER,
        payload: request
    }
}

export function loginUser(dataToSubmit) {
    // console.log('testest');
    const request = axios.post(`/v1/admin/account/login`, dataToSubmit)
        .then(response => response.data);

    return {
        type: LOGIN_USER,
        payload: request
    }
}


export function auth(adminToken) {
    const request = axios.post(`/v1/admin/account/auth`, adminToken)
        .then(response => response.data);

    return {
        type: AUTH_USER,
        payload: request
    }
}

export function logoutUser() {
    const request = axios.get(`/v1/admin/account/logout`)
        .then(response => response.data);

    return {
        type: LOGOUT_USER,
        payload: request
    }
}


export async function chatbotLogin(formData, config) {

    const request = await axios.post('/v1/bot/kolas/loginKolasService', formData, config)

    return {
        type: CHATBOT_LOGIN,
        payload: request
    }
}

export async function getWelcome(libName) {
    // console.log('libName', libName);


    const request = await axios.get(`/v1/bot/welcome?libName=${libName}`)

    return {
        type: GET_WELCOME_LIST,
        payload: request
    }
}



// export async function resetContext(formData, config) {

//     const request = await axios.delete('/v1/bot/dfContextReset', formData, config)
      
//     return {
//         type: CHATBOT_USER,
//         payload: request
//     }
// }